import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import RevisionDetail from '../RevisionDetail';

export default function TdaUserProfileRevisionButton(props) {
  const [modalData, setModalData] = React.useState({
    visible: false,
  });

  return (
    <>
      <Ant.Button
        onClick={() => {
          setModalData({visible: true});
        }}>
        資料異動紀錄
      </Ant.Button>
      <TdaUserProfileRevisionModal
        close={() => setModalData({visible: false})}
        {...modalData}
        {...props}
      />
    </>
  );
}

function TdaUserProfileRevisionModal(props) {
  const {visible, close} = props;
  return (
    <Ant.Modal
      title={null}
      footer={null}
      bodyStyle={{padding: 0}}
      width={960}
      open={visible}
      onOk={close}
      onCancel={close}
      destroyOnClose={true}>
      {visible && <ModalContent {...props} />}
    </Ant.Modal>
  );
}

function ModalContent(props) {
  const [records, setRecords] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState('');

  React.useEffect(() => {
    async function fetchData() {
      const [err, resp] = await AppActions.tryError(
        JStorage.fetchAllDocuments('revision', {
          collection: 'user_profile',
          owner: props.owner,
        }),
      );
      if (resp) {
        setRecords(resp);
      }
    }

    fetchData();
  }, [props.owner]);

  return (
    <Wrapper>
      <h2 style={{marginBottom: 30}}>修改紀錄</h2>

      {selectedId ? (
        <div>
          <Ant.Button
            style={{marginBottom: 20}}
            onClick={() => setSelectedId()}>
            返回列表
          </Ant.Button>
          <RevisionDetail id={selectedId} />
        </div>
      ) : (
        <Ant.Table
          columns={[
            {
              title: '日期',
              key: 'date',
              render: (_, record) => {
                return (
                  <div>{new Date(record.created).toLocaleString('sv')}</div>
                );
              },
            },
            {
              title: '審核狀態',
              key: 'status',
              render: (_, record) => {
                return {
                  pending: '審核中',
                  approved: '審核完成',
                  rejected: '拒絕修改',
                }[record.status];
              },
            },
            {
              title: '項目',
              key: 'keys',
              render: (_, record) => {
                return (
                  <Ant.Button onClick={() => setSelectedId(record.id)}>
                    查看
                  </Ant.Button>
                  // <ul>
                  //   {record.keys.map((k, idx) => {
                  //     return (
                  //       <li key={k} style={{textWrap: 'wrap'}}>
                  //         {`${findFieldTitle(k)} 由 ${JSON.stringify(
                  //           record.olds[idx],
                  //           null,
                  //           2,
                  //         )} 改為 ${JSON.stringify(record.news[idx], null, 2)}`}
                  //       </li>
                  //     );
                  //   })}
                  // </ul>
                );
              },
            },
          ]}
          rowKey={'id'}
          dataSource={records}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 20px;
`;
